var map = {
	"./academy-module.png": "5Q0m",
	"./ahib-academy-cover.png": "LUev",
	"./ahib-researchportal-cover.png": "rxNR",
	"./bubbletea-cover.png": "C3oz",
	"./chatbot-theme-web-app.png": "UiDp",
	"./company-about-us-page.png": "mXhl",
	"./einvest-aboutus-cover.png": "SgZ9",
	"./einvest-ekyc-cover.png": "yQVR",
	"./facial-recognition.png": "sl3P",
	"./homecooked-cover.png": "bAY3",
	"./leave-management-mobile-app.png": "cqY2",
	"./mynjoi-onboarding-cover.png": "TpQn",
	"./mynjoi-onboarding-details.jpg": "1TLp",
	"./mynjoi-refreshsmartcard-cover.png": "HS18",
	"./mynjoi-tvschedule-cover.png": "7n6e",
	"./njoi-productsignup-cover.png": "pyCZ",
	"./online-account-registration.png": "Hb0V",
	"./sooka-launchprompt-cover.png": "Ww87",
	"./sooka-subscription-cover.png": "vSDU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bWdm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works ^\.\/.*$
// module id = bWdm
// module chunks = 1